var PasswordResetCtrl = function (gettextCatalog, AppUser, $state, $stateParams, Notification) {
  this._AppUser = AppUser;
  this._state = $state;
  this._Notification = Notification;
  this.gettextCatalog = gettextCatalog;
  this.credentials = {};
  this.hasErrors = false;
  this.formSubmitted = false;
  this._accessToken = $stateParams.token;
};

PasswordResetCtrl.prototype.send = function() {
  var self = this;
  this
    ._AppUser
    .setPassword(
      {
        access_token: this._accessToken
      },
      this.credentials,
      function () {
        self._Notification.success(self.gettextCatalog.getString('Passwort zurückgesetzt'));
        self._state.go('login');
      },
      function () {
        self._Notification.error(self.gettextCatalog.getString('Passwort konnte nicht zurückgesetzt werden'));
      });
};

module.exports = PasswordResetCtrl;




// WEBPACK FOOTER //
// ./client/src/app/modules/login/PasswordResetCtrl.js